import baseApi from '@store/api/baseApi';

export const MultipleTechpackJourneyApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		uploadMultipleTechpack: builder.mutation({
			query: (requestBody) => ({
				url: '/product/upload-documents/initiate',
				method: 'POST',
				body: requestBody,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),
		uploadFileToS3: builder.mutation({
			queryFn: async ({ url, file }) => {
				try {
					const response = await fetch(url, {
						method: 'PUT',
						body: file,
						headers: {
							'Content-Type': file.type,
							'x-amz-acl': 'public-read'
						}
					});
					return response.ok
						? { data: null }
						: { error: { status: response.status, data: await response.text() } };
				} catch (error) {
					return { error: { status: 'FETCH_ERROR', error: error?.message } };
				}
			}
		}),

		uploadDocument: builder.mutation({
			query: (requestBody) => ({
				url: '/product/extract-first-pages',
				method: 'POST',
				body: requestBody,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),
		uploadFormInspiration: builder.mutation({
			query: (requestBody) => ({
				url: '/product/add-from-inspiration',
				method: 'POST',
				body: requestBody,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),
		getExtractionPendingList: builder.query({
			query: (arg) => {
				const isObjectArg = typeof arg === 'object' && arg !== null;
				const collectionId = isObjectArg ? (arg.collectionId ?? arg.id) : arg;
				const params = isObjectArg ? arg.params : undefined;

				return {
					url: `/product/pending-info-extraction/${collectionId}`,
					method: 'GET',
					params
				};
			}
		}),
		productAnalyzeDocument: builder.mutation({
			query: (requestBody) => ({
				url: '/product/analyze-documents',
				method: 'POST',
				body: requestBody.productIds,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),
		removeFileFromCollection: builder.mutation({
			query: (requestBody) => ({
				url: '/collection/product/remove',
				method: 'POST',
				body: requestBody,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),

		//get list data
		getWashList: builder.query({
			query: () => ({
				url: '/garment-treatment/wash-category-list',
				method: 'GET'
			}),
			providesTags: ['GET_WASH_LIST']
		}),
		getPrintList: builder.query({
			query: () => ({
				url: '/garment-treatment/print-category-list',
				method: 'GET'
			}),
			providesTags: ['GET_PRINT_LIST']
		}),

		getEmbroideryList: builder.query({
			query: () => ({
				url: '/garment-treatment/embroidery-category-list',
				method: 'GET'
			}),
			providesTags: ['GET_EMBROIDERY_LIST']
		}),

		getCategorySubCategoryList: builder.query({
			query: () => ({
				url: '/category/v2/subcategory',
				method: 'GET'
			})
		}),
		getMarketList: builder.query({
			query: () => ({
				url: '/product-group/all',
				method: 'GET'
			}),
			providesTags: ['GET_MARKET_LIST']
		}),
		getFabricTypeList: builder.query({
			query: () => ({
				url: '/material/fabric-type/all',
				method: 'GET'
			}),
			providesTags: ['GET_FABRIC_TYPE_LIST']
		}),
		getCompositionNameList: builder.query({
			query: () => ({
				url: '/material/fabric/composition-name-list',
				method: 'GET'
			}),
			providesTags: ['GET_COMPOSITION_NAME_LIST']
		}),
		getMetarialFabricList: builder.query({
			query: ({ type = 'FABRIC', search = {}, page = 0, size = 20 } = {}) => ({
				url: '/material/all/material-brief',
				method: 'GET',
				params: {
					page,
					size,
					supplierType: type,
					...search
				}
			})
		}),
		materialSearchOrAdd: builder.mutation({
			query: (requestBody) => ({
				url: '/material/search-or-add',
				method: 'POST',
				body: requestBody
			})
		}),
		setProductStyleInfo: builder.mutation({
			query: ({ id, requestBody }) => ({
				url: `/product/style-info/${id}`,
				method: 'PUT',
				body: requestBody
			})
		}),
		setProductInfo: builder.mutation({
			query: ({ id, requestBody }) => ({
				url: `/product/${id}/update-checklist`,
				method: 'PUT',
				body: requestBody
			})
		}),
		getMaterialConstructions: builder.query({
			query: () => ({
				url: '/material/fabric/constructions',
				method: 'GET'
			})
		})
	})
});
export const {
	useUploadMultipleTechpackMutation,
	useUploadFileToS3Mutation,
	useUploadDocumentMutation,
	useUploadFormInspirationMutation,
	useGetExtractionPendingListQuery,
	useProductAnalyzeDocumentMutation,
	useRemoveFileFromCollectionMutation,
	useGetWashListQuery,
	useGetPrintListQuery,
	useGetEmbroideryListQuery,
	useGetCategorySubCategoryListQuery,
	useGetMarketListQuery,
	useGetFabricTypeListQuery,
	useGetCompositionNameListQuery,
	useGetMetarialFabricListQuery,
	useMaterialSearchOrAddMutation,
	useSetProductStyleInfoMutation,
	useSetProductInfoMutation,
	useGetMaterialConstructionsQuery
} = MultipleTechpackJourneyApi;
